/**
 * TermsDialog
 * -----------
 * In-place Terms of Service modal opened from within other flows
 * (currently: the Platform Fee Agreement dialog). Rendering the terms
 * inline — rather than navigating to /terms — keeps the caller's flow
 * context intact so the user never has to worry about back navigation
 * or reopening the prior dialog.
 *
 * Uses the same underlying Shadcn Dialog primitive as the rest of the
 * app. Radix handles stacking, scroll trap, and focus restoration on
 * close automatically, so reopening the parent flow works out of the box.
 */

import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';
import TermsContent from './TermsContent';

const TermsDialog = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-2xl max-h-[85vh] p-0 overflow-hidden flex flex-col"
        data-testid="terms-dialog"
      >
        <DialogHeader className="px-6 pt-6 pb-3 border-b">
          <DialogTitle className="text-lg">Terms of Service</DialogTitle>
          <DialogDescription className="text-xs text-gray-400">
            Last updated: April 2026
          </DialogDescription>
        </DialogHeader>
        <div
          className="flex-1 overflow-y-auto px-6 py-5"
          data-testid="terms-dialog-body"
        >
          <TermsContent />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TermsDialog;
